<template>
	<div class="owl-carousel">
		<!-- <pre>{{items}}</pre> -->
		<template v-for='item in items'>
			<div class="item" :style='`background-image: url(${item.image})`'>
				<div class="text">
					<div class="header">{{item.text.header}}</div>
					<div class="small">{{item.text.small}}</div>
					<div class="big">{{item.text.big}}</div>
				</div>

				<a :href='item.button.href' class="button">{{item.button.name}}</a>
			</div>
		</template>
	</div>
</template>

<script>
module.exports = {

	props: ['items'],

	data () {
		return {}
	},

	updated() {
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: this.items.length > 1 ? true : false
			}
		});
	}
}
</script>

<style lang="scss">
@import "scss/wanted";
.global-slider-container {
	.slider-default {
		height: 300px;
		overflow: hidden;

		.owl-carousel {

			.item {
				height: 300px;
				background-position: center;
				background-size: cover;
				display: flex;
				align-items: center;
				justify-content: center;

				.text {
					background-color: rgba(#fff, .5);
					padding: 10px;
					box-shadow: 0 0 10px #fff;

					.header {
						text-transform: uppercase;
						font-weight: 700;
					}

					.small {

					}

					.big {

					}
				}

				.button {
					display: inline-block;
					padding: 10px 20px;
					background-color: #fff;
					margin: 0 0 0 50px;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// default.vue?2c321411